module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/timesheets/timesheets.html
// module id = 520
// module chunks = 0